/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const BarLineChart = ({ datasets, chartData, title, height, width="100%", minval}) => {
  
  const data = {
    labels: chartData.map((item) => item.month),
    datasets: datasets
  };

  // const options = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     // title: {
  //     //   display: true,
  //     //   text: title,
  //     //   font: {
  //     //     size: 18,
  //     //   },
  //     // },
  //     // legend: {
  //     //   position: "bottom",
  //     // },
  //     datalabels: {
  //       color: "black",
  //       // anchor: "end",
  //       // align: "top",
  //       // font: {
  //       //   weight: "bold",
  //       // },
  //     },
  //     legend: {
  //       labels: {
  //         usePointStyle: true,
  //         pointStyle: "rectRot",
  //         font: {
  //           size: 10  // <-- Change legend font size here
  //         }
  //       },
  //       // onClick(e) {
  //       //   if (e.stopPropagation) e.stopPropagation();
  //       // },
  //       position: "bottom",
  //     },
  //     tooltip: {
  //       mode: "index",
  //       intersect: false,
  //     },
  //   },
  //   scales: {
  //     y: {
  //       beginAtZero: true,
  //       title: {
  //         display: true,
  //         // text: "Count",
  //       },
  //     },
  //     y1: {
  //       beginAtZero: true,
  //       position: "right",
  //       min: minval,
  //       max: 102,
  //       title: {
  //         display: true,
  //         // text: "Percentage (%)",
  //       },
  //       ticks: {
  //         callback: function (value) {
  //           return value + "%";
  //         },
  //       },
  //       grid: {
  //         drawOnChartArea: false,
  //       },
  //     },
  //   },
  // };

  // const options = {
  //   // indexAxis: indexAxis,
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   layout: {
  //     padding: {
  //       top: 30,   // <-- adds space below legend
  //     },
  //   },
  //   plugins: {
  //     legend: {
  //       labels: {
  //         usePointStyle: true,
  //         pointStyle: "circle",
  //         font: {
  //           size: 8,
  //           weight: "bold",
  //         },
  //       },

  //       // onClick(e) {
  //       //   if (e.stopPropagation) e.stopPropagation();
  //       // },
  //       position: "top",
  //     },
  //     datalabels: {
  //       color: "white",
  //       anchor: "center",
  //       align: "center",
  //       // display: "auto",
  //       // clip: "auto",
  //       font: {
  //         weight: "bold",
  //         size: 10,
  //       },
  //     },
  //     tooltip: {
  //       intersect: false,
  //     },    
  //   },
  //   scales: {
  //         y: {
  //           beginAtZero: true,
  //           title: {
  //             display: true,
  //             // text: "Count",
  //           },
  //         },
  //         y1: {
  //           beginAtZero: true,
  //           position: "right",
  //           min: minval,
  //           max: 102,
  //           title: {
  //             display: true,
  //             // text: "Percentage (%)",
  //           },
  //           ticks: {
  //             callback: function (value) {
  //               return value + "%";
  //             },
  //           },
  //           grid: {
  //             drawOnChartArea: false,
  //           },
  //         },
  //       }
  // };

  const options = {
    // indexAxis: indexAxis,
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30,   // <-- adds space below legend
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          // padding: 20,
          font: {
            size: 8,
            weight: "bold",
          },
        },
      },        
      datalabels: {
        color: "black",
        textStrokeColor: "white",   // White border
        textStrokeWidth: 4,         // Thickness of border
        anchor: "end",
        align: "end",
        // rotation: 90, 
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
      },
      tooltip: {
        intersect: false,
      },    
    },
    scales: {
          x: {
            display: true,
            ticks: {
              display: true,
              font: {
                size: 10,
                // weight: 'bold',
              },
            },
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: false,
              // text: "Count",
            },
            ticks: {
              display: true,
              font: {
                size: 10,
                // weight: 'bold',
              },
            },
            grid: {
              display: false,
            },
          },
          y1: {
            beginAtZero: true,
            position: "right",
            min: minval,
            // max: 110,
            title: {
              display: false,
              // text: "Percentage (%)",
            },
            ticks: {
              display: true,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
              // drawOnChartArea: false,
            },
          },
        }
  };

  return (
    <div className="w-full p-2 bg-white rounded-xl"  style={{ height: `${height}px`, width: `${width}%` }}>
      <Chart data={data} options={options} />
    </div>
  );
};

export default BarLineChart;